import { render, staticRenderFns } from "./CancelaToca.vue?vue&type=template&id=6feb1590&"
import script from "./CancelaToca.vue?vue&type=script&lang=js&"
export * from "./CancelaToca.vue?vue&type=script&lang=js&"
import style0 from "./CancelaToca.vue?vue&type=style&index=0&id=6feb1590&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports